
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import {
  setGcashGroup,
  addGcashGroup,
  delGcashGroup,
  getAllGcash
} from '@/api/gcash/groups'
import {
  editMultipleGcashAccount,
  editGcashAccount,
  getGcashAccountList,
  delGcashAccount
} from '@/api/gcash/account'
import { AppModule } from '@/store/modules/app'
import { delObjEmptyKey } from '@/utils'
import { Form as ElForm } from 'element-ui'

@Component({
  name: 'group',
  components: {}
})
export default class extends Vue {
  // @Prop({ required: true }) list!: any
  get language() {
    return AppModule.language
  }

  private rules:any = {
    group_name: [
      {
        required: true, message: 'Please enter group name', trigger: 'change'
      }
    ]
    // account: [
    //   {
    //     required: true, message: 'Please enter account', trigger: 'change'
    //   }
    // ]
  }
  private ruleForm:any = {}

  private activeName: any = '1'
  private changeTabs (val) {
    if (val.name === '2') {
      this.onloadGroupList()
      this.hadleGetFilesListApi()
    }
  }

  private groupName: any = ''
  private listLoading: boolean = false

  // 分组列表
  private groupList: any = []
  private async onloadGroupList() {
    try {
      this.listLoading = true
      let params: any = {
        page_size: 100,
        page: 1
      }
      await getAllGcash(params).then((res: any) => {
        this.groupList = res.results
        this.listLoading = false
      })
    } catch (e) {
      this.listLoading = false
    }
  }

  // 分页器设置
  private pagesize: number = 1000

  // 分页切换
  private currentPage: number = 1
  private list: any[] = []
  private total: number = 0
  private async hadleGetFilesListApi() {
    try {
      this.listLoading = true
      const data: any = {
        page_size: this.pagesize,
        page: this.currentPage
      }
      delObjEmptyKey(data)
      await getGcashAccountList(data).then((res: any) => {
        this.list = res.results
        this.total = res.count
        this.listLoading = false
      })
    } catch (error) {
      this.list = []
      this.listLoading = false
    }
  }

  // 添加分组
  private gcashGroupVisible: boolean = false
  private addGcashGroup() {
    this.gcashGroupVisible = true
  }
  private closeGroup() {
    this.gcashGroupVisible = false
    this.groupName = ''
    this.editRow = {}
    this.isEdit = false
    this.onloadGroupList()
  }
  private async create() {
    try {
      if (this.isEdit) {
        const data: any = {
          id: this.editRow.id,
          group_name: this.groupName
        }
        await setGcashGroup(data).then(() => {
          this.$message({
            message: 'Edit Successful!',
            type: 'success'
          })
          this.closeGroup()
        })
      } else {
        const data: any = {
          group_name: this.groupName
        }
        await addGcashGroup(data).then(() => {
          this.$message({
            message: 'Create Successful!',
            type: 'success'
          })
          this.closeGroup()
        })
      }
    } catch (e) {
      this.closeGroup()
    }
  }
  // 编辑分组
  private isEdit: boolean = false
  private editRow: any = {}
  private openEditGroup(row: any) {
    this.editRow = row
    this.isEdit = true
    this.groupName = row.group_name
    this.gcashGroupVisible = true
  }
  // 删除分组
  private delGroup(id: any) {
    this.$confirm('Are you sure to delete it?', {
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
      type: 'warning',
      callback: action => {
        const data: any = {
          id: id
        }
        if (action === 'confirm') {
          delGcashGroup(data).then(() => {
            this.$message({
              type: 'success',
              message: 'Delete successful!'
            })
            this.onloadGroupList()
          })
        }
      }
    })
  }

  // 分组管理操作
  private groupManageVisible: any = false
  private groupManageData: any = {}
  private openEdit(row: any) {
    this.groupManageVisible = true
    this.groupManageData = row
    this.groupName = row.gcash_groups
  }

  private closeGroupManage() {
    this.groupName = ''
    this.groupManageData = {}
    this.groupManageVisible = false
  }
  private async save() {
    try {
      // this.loading = true
      const data: any = {
        id: this.groupManageData.id,
        gcash_groups: this.groupName
      }
      await editGcashAccount(data).then((res: any) => {
        this.$message({
          message: 'Edit successful!',
          type: 'success'
        })
        this.closeGroupManage()
        this.hadleGetFilesListApi()
      })
    } catch (error) {}
  }
  private activeList: any = []
  //  private handleSelectionChange(list) {
  //    this.activeList = list
  //  }

  private allGroupManageVisible: any = false
  private editGroupManage() {
    this.allGroupManageVisible = true
  }

  private closeAllGroupManage() {
    this.groupName = ''
    this.activeList = []
    this.checkAll = false
    this.isIndeterminate = false
    this.allGroupManageVisible = false
  }

  private errorFlag: boolean = false
  private errorText: string = 'Please select group'
  private async allSave() {
    // (this.$refs.assignForm as ElForm).validate(async (valid: boolean) => {
    //   if (valid) {
    try {
      if (this.groupName === '') {
        this.errorFlag = true
      }
      if (this.groupName === '') return false
      if (this.activeList.length === 0) return this.$message.error('Please select account!')
      let arr: any = []
      this.activeList.forEach(item => {
        arr.push({
          gcash_groups: this.groupName,
          account_id: item.account_id,
          phone_number: item.phone_number,
          account_password: item.account_password,
          id: item.id
        })
      })
      const data: any = {
        ...arr
      }
      delObjEmptyKey(data)
      await editMultipleGcashAccount(data).then((res: any) => {
        this.$message.success('Edit Successfully')
        this.activeName = '1'
        this.errorFlag = false
        this.closeAllGroupManage()
        this.hadleGetFilesListApi()
      })
    } catch (error) {
      console.log()
    }
  }

  private checkAll: any = false
  private isIndeterminate: any = false
  private clickItem(row: any) {
    this.activeList = this.list.filter(item => {
      return item.gcash_groups === row
    })
    this.checkAll = this.activeList.length === this.list.length
    this.isIndeterminate =
      this.activeList.length > 0 && this.activeList.length < this.list.length
  }

  handleCheckAllChange(val) {
    this.activeList = val ? this.list : []
    this.isIndeterminate = false
  }
  handleCheckedCitiesChange(value) {
    let checkedCount = value.length
    this.checkAll = checkedCount === this.list.length
    this.isIndeterminate = checkedCount > 0 && checkedCount < this.list.length
    this.activeList = value
  }

  mounted() {
    this.onloadGroupList()
  }
}
